import { Flex, Button } from '@chakra-ui/react';

const ACTIVE_GRADIENT =
  'linear-gradient(180deg, #FF9554 16%, #FF6F45 55%, #FF4935 88%)';
const ACTIVE_BG = '#FF4935';
const INACTIVE_BG = '#e8e8e8';
const INACTIVE_COLOR = '#4c4c4c';

const BillingIntervalToggle = ({
  value,
  onChange,
  size = 'md',
  annualLabel = 'Annually',
  gradient = true,
}) => {
  const h = size === 'sm' ? '40px' : '44px';
  const fontSize = '14px';
  const minW = '80px';
  const outerRadius = '10px';

  const segmentProps = (side, selected) => {
    const isLeft = side === 'left';
    return {
      flex: 1,
      minW,
      h,
      px: 4,
      py: 0,
      fontSize,
      lineHeight: 1,
      border: 'none',
      borderRadius: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition:
        'background 0.2s ease, color 0.2s ease, font-weight 0.15s ease',
      ...(isLeft
        ? {
            borderTopLeftRadius: outerRadius,
            borderBottomLeftRadius: outerRadius,
          }
        : {
            borderTopRightRadius: outerRadius,
            borderBottomRightRadius: outerRadius,
          }),
      ...(selected
        ? {
            bg: gradient ? ACTIVE_GRADIENT : ACTIVE_BG,
            color: 'white',
            fontWeight: 700,
            _hover: {
              bg: gradient ? ACTIVE_GRADIENT : ACTIVE_BG,
              filter: 'brightness(0.97)',
            },
          }
        : {
            bg: INACTIVE_BG,
            color: INACTIVE_COLOR,
            fontWeight: 400,
            _hover: { bg: '#d5d5d5' },
          }),
      _focusVisible: {
        zIndex: 1,
        boxShadow: '0 0 0 2px rgba(255, 149, 84, 0.45)',
      },
      _active: {
        transform: 'none',
      },
    };
  };

  return (
    <Flex
      role="group"
      w="fit-content"
      borderRadius={outerRadius}
      overflow="hidden"
      boxShadow="none"
    >
      <Button
        type="button"
        variant="unstyled"
        aria-pressed={value === 'month'}
        onClick={() => onChange('month')}
        {...segmentProps('left', value === 'month')}
      >
        Monthly
      </Button>
      <Button
        type="button"
        variant="unstyled"
        aria-pressed={value === 'year'}
        onClick={() => onChange('year')}
        {...segmentProps('right', value === 'year')}
      >
        {annualLabel}
      </Button>
    </Flex>
  );
};

export default BillingIntervalToggle;
